module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/shield-check-89fffa4739f437656a98ac1a731246f2.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/shield-check.svg
// module id = rm/P
// module chunks = 24